var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { staticClass: "checkbox" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.stateValue,
            expression: "stateValue",
          },
        ],
        staticClass: "input-checkbox",
        attrs: { type: "checkbox", title: _vm.title },
        domProps: {
          checked: Array.isArray(_vm.stateValue)
            ? _vm._i(_vm.stateValue, null) > -1
            : _vm.stateValue,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.stateValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.stateValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.stateValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.stateValue = $$c
              }
            },
            _vm.change,
          ],
        },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "i-custom-checkbox",
        class: _vm.customCheckboxClassName,
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }